import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FeatherModule } from 'angular-feather';

import { EventService } from '~/v2/core/services/event.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-return-bar',
  templateUrl: './return-bar.component.html',
  imports: [FeatherModule],
})
export class ReturnBarComponent implements OnInit {
  @Input() text: string | null = null;
  @Input() showReturnIcon = true;
  @Input() returnUrl: string | null = null;

  private router: Router;
  private eventService: EventService;
  private cdr = inject(ChangeDetectorRef);

  constructor(router: Router, eventService: EventService) {
    this.router = router;
    this.eventService = eventService;
  }

  ngOnInit(): void {
    if (this.returnUrl == null) {
      this.setReturnUrlFromRoute();
    }
  }

  returnToPreviousRoute(): void {
    this.router.navigate([this.returnUrl]);
  }

  private setReturnUrlFromRoute(): void {
    this.eventService.previousNavigatedRoute.subscribe((r) => {
      this.returnUrl = r;
      this.cdr.markForCheck();
    });
  }
}
